import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { PreLoader } from 'components/preLoader/preLoader';
import { recordedInitialPage } from 'utilities/uTagging';
import Storage from 'utilities/storage';

export const Login = ({ stepsActions, options, storage }) => {
    const { token } = useParams();

    useEffect(() => {
        const decodedToken = JSON.parse(atob(token));
        const { onboardingToken, openBankAuthToken } = decodedToken;

        Storage.cookies.set('openBankToken', openBankAuthToken);

        const professionalCategories = options.get('professionalCategories');
        stepsActions.getInformationByToken(onboardingToken, professionalCategories, true, storage);

        recordedInitialPage();
    }, [options, stepsActions, token]);

    return <PreLoader show />;
};

Login.propTypes = {
    stepsActions: PropTypes.object,
    options: PropTypes.object,
    storage: PropTypes.func,
};
